"use client";

import {
  MONDAY_READ_TOOLS,
  MONDAY_WRITE_TOOLS,
} from "@workspace/connectors/definitions";
import { lazy } from "react";
import { createMcpToolRegistry } from "../mcp-tool-registry";

const mondayMcpToolView = lazy(() =>
  import("./tool-view").then(({ MondayMcpToolView }) => ({
    default: MondayMcpToolView,
  }))
);

/**
 * monday.com is an MCP + progressive-disclosure capability — its tool parts
 * arrive as `monday_${mcpToolName}`. See `createMcpToolRegistry`.
 */
export const mondayToolRegistry = createMcpToolRegistry({
  prefix: "monday",
  readTools: MONDAY_READ_TOOLS,
  writeTools: MONDAY_WRITE_TOOLS,
  view: mondayMcpToolView,
});
